<template>
  <!-- Footer -->
  <footer id="krds-footer">
        <div class="inner">
          <div class="f-logo">
            <img src="@/assets/img/logo.svg" alt="차세대정보보안인증원" />
          </div>
          <div class="f-cnt">
            <div class="f-info">
              <p class="info-addr">
                <span>
                  <span>{{ organ.addr }}</span>
                </span>
              </p>
              <ul class="info-cs">
                <li>
                  <strong class="strong">전화번호</strong
                  >&nbsp;<span class="span">{{ organ.tel }}</span>
                </li>
                <li>
                  <strong class="strong">이메일</strong
                  >&nbsp;<span class="span">{{ organ.email }}</span>
                </li>
              </ul>
            </div>

            <div class="f-link">
              <div class="link-go">
                <a href="javascript:void(0);" class="krds-btn medium text" @click="doContentLink('M0009', 'M0001')">찾아오시는 길 <i class="svg-icon ico-angle right"></i></a>
              </div>
              <div class="link-sns">
                <a v-for="(item, index) in snsLinkList.slice(0, 5)" :key="index" v-html="$sanitize(item.content)" class="krds-btn xlarge icon border" :href="item.url" target="_blank" :title="item.title">
                </a>
              </div>
            </div>
          </div>

          <div class="f-btm">
            <div class="f-btm-text">
              <p class="f-copy">
                © 2025 NISC All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
</template>

<script>
export default {
  props: {
    organ: {
      type: Object,
      default: () => ({})
    }
    ,snsLinkList:{
      type: Array,
      default: () => []
    }
  },
  methods: {
    doContentLink(menuId, upMenuId) {
      this.$router.push({name:'isoti_content', query: {menuId: menuId, upMenuId: upMenuId, s0: null}})
    },
  }
}
</script>
